// PERMANENT: Contact page — required for AdSense compliance. Do not remove.
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, ExternalLink } from "lucide-react";
import SeoHead from "@/components/SeoHead";

const NAVY = "#1B2F5E";
const GOLD = "#C9A96E";

export default function ContactPage() {
  return (
    <div className="min-h-screen topo-bg" data-testid="contact-page">
      <SeoHead
        title="Contact"
        description="Contact Summary Maps LLC — questions, feedback, or collaboration."
      />
      <main className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-16 pb-20 sm:pb-24" style={{ maxWidth: 720 }}>
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-muted hover:text-brand mb-8" data-testid="back-link">
          <ArrowLeft className="w-4 h-4" /> Back to the journal
        </Link>

        <div className="text-xs uppercase tracking-[0.22em] font-semibold mb-3" style={{ color: GOLD }}>Get in touch</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-semibold leading-tight" style={{ color: NAVY }}>Contact Us</h1>

        <p className="mt-6 text-lg leading-relaxed" style={{ color: "#2D3748" }}>
          Have a question, a book you'd like us to map, or want to collaborate? Reach out.
        </p>

        <div
          className="mt-10 rounded-2xl px-6 sm:px-8 py-7 sm:py-8"
          style={{
            background: "#fff",
            border: `1px solid ${GOLD}55`,
            boxShadow: "0 12px 40px -20px rgba(27, 47, 94, 0.28)",
          }}
        >
          <div className="flex items-start gap-4">
            <span
              className="inline-flex items-center justify-center w-11 h-11 rounded-full shrink-0"
              style={{ background: `${GOLD}22`, color: GOLD }}
            >
              <Mail className="w-5 h-5" />
            </span>
            <div>
              <div className="text-xs uppercase tracking-[0.18em] mb-1" style={{ color: "#5C5344" }}>Email</div>
              <a
                href="mailto:contact@summarymaps.com"
                className="font-serif text-2xl sm:text-3xl font-semibold hover:underline"
                style={{ color: GOLD }}
                data-testid="contact-email"
              >
                contact@summarymaps.com
              </a>
              <p className="mt-2 text-sm" style={{ color: "#4A5568" }}>
                We read every message and reply within a couple of business days.
              </p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t" style={{ borderColor: `${NAVY}15` }}>
            <div className="text-xs uppercase tracking-[0.18em] mb-1" style={{ color: "#5C5344" }}>Company</div>
            <div className="text-base" style={{ color: NAVY, fontWeight: 500 }}>Summary Maps LLC</div>

            <a
              href="https://summarymaps.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium hover:underline"
              style={{ color: NAVY }}
              data-testid="contact-app-link"
            >
              Visit summarymaps.com <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
